var _metadata, _defs, _desc;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgContinueButton(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "115px",
    height: "55px",
    viewBox: "0 0 115 55",
    id: "svg13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "metadata19"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs17"
  })), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title2"
  }, "svg/nextButton") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title2"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "desc4"
  }, "Created with Sketch.")), /*#__PURE__*/React.createElement("path", {
    d: "M 69.006087,8.0352734 C 47.913188,8.4403807 19.192114,5.7919012 7.064152,15.817895 2.7094496,19.417858 1.5283992,30.87689 2.1574084,38.111927 3.8687079,50.387672 20.480445,51.770256 34.970502,52.432485 c 18.390509,0.840488 37.753276,0.667985 51.639436,0 14.882992,-1.46249 26.601322,-1.46249 26.387172,-20.937223 -0.05,-4.548352 -0.20322,-10.099496 -3.66623,-14.160494 -8.85354,-8.2167466 -26.187002,-9.049 -40.324793,-9.2994946 z",
    id: "SHADOW",
    style: {
      opacity: 0.2,
      mixBlendMode: "multiply",
      fill: "#000000",
      fillRule: "evenodd",
      stroke: "#000000",
      strokeWidth: 2.5,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 69.006087,2.0352734 C 47.913188,2.4403807 19.192114,-0.2080988 7.064152,9.8178947 2.7094496,13.417858 1.5283992,24.87689 2.1574084,32.111926 3.8687079,44.387672 20.480445,45.770256 34.970502,46.432485 c 18.390509,0.840488 37.753276,0.667985 51.639436,0 14.882992,-1.46249 26.601322,-1.46249 26.387172,-20.937223 -0.05,-4.548352 -0.20322,-10.099496 -3.66623,-14.160494 -8.85354,-8.2167466 -26.187002,-9.049 -40.324793,-9.2994946 z",
    id: "STROKE_99fb390a-b112-4495-90fb-e96524237ba6",
    style: {
      fill: "#87bc4b",
      fillRule: "evenodd",
      stroke: "#000000",
      strokeWidth: 2.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 16,39.486443 c 14.489255,2.75165 73.685161,4.195155 86.20919,-0.774966 C 108.3223,36.285512 109.28873,25.211551 106.54143,17",
    id: "Path",
    style: {
      fill: "none",
      fillRule: "evenodd",
      stroke: "#6b953b",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 102,13.247563 C 93.777577,7.9947442 73.19567,7.1809262 62.128246,7.1189958 45.970647,6.8416326 36.533011,6.8071403 20.948178,9.8177418 12.765239,11.893926 8.6735364,14.817888 7.5972802,22.4836 6.521024,30.149311 6.4606847,34.169938 11.209884,37",
    id: "path9",
    style: {
      fill: "none",
      fillRule: "evenodd",
      stroke: "#b3d58e",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeOpacity: 1
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContinueButton);
export default __webpack_public_path__ + "static/media/continueButton.08ba90d1d857c324e20cab22f70eff18.svg";
export { ForwardRef as ReactComponent };